import { render } from "./NewOrderDialog.vue?vue&type=template&id=72781326"
import script from "./NewOrderDialog.vue?vue&type=script&lang=js"
export * from "./NewOrderDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__